export default "__VITE_ASSET__CDFb2pQV__"